'use client';

import useSWR from 'swr';
import { categoryBudgetApi } from '@/lib/api';
import type { CustomCategorySummary } from '@/types';
import { TRANSACTION_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

/** Active custom categories, for pickers outside the Categorias overview. */
export function useCustomCategories(enabled: boolean) {
  const authedFetch = useAuthedFetcher();

  return useSWR<CustomCategorySummary[]>(
    enabled ? ['custom-categories'] : null,
    () => authedFetch((token) => categoryBudgetApi.getCustomCategories(token)),
    TRANSACTION_SWR_OPTIONS,
  );
}
